import type { Character } from "@dm/shared";

/** A character's uploaded avatar, or their initials when there isn't one. */
export function Avatar({ c, name, size = 28 }: { c?: Pick<Character, "name" | "avatarUrl"> | null; name?: string; size?: number }) {
  const label = c?.name || name || "?";
  const initials = label.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join("") || "?";
  const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };
  return c?.avatarUrl
    ? <img className="avatar" src={c.avatarUrl} alt="" style={style} loading="lazy" />
    : <span className="avatar avatar-initials" style={style} aria-hidden="true">{initials}</span>;
}

/** Find the party member a combatant or transcript speaker refers to. */
export function findInParty(party: Character[], key: { characterId?: number | null; name?: string | null }): Character | null {
  if (key.characterId) return party.find((c) => c.id === key.characterId) ?? null;
  const n = key.name?.trim().toLowerCase();
  if (!n) return null;
  return party.find((c) => c.name.toLowerCase() === n || c.ownerName.toLowerCase() === n) ?? null;
}
